export const LANG_en_gb = 'en_GB';
export const LANG_en_us = 'en_US';
